import React, { Component } from 'react';

import { isEmptyObject } from '../../../../../utils/utils';
import { trans } from '../../../../../localization';

function OtherDiscountItem({ discount }) {
  const {
    name, code, text,
  } = discount;
  return (
    <div className="row mb-1">
      <div className="col-9 text-left">
        {`${name} `}
        <button className="promocode-text">{code}</button>
      </div>
      <div className="col-3 text-right text-danger">-{text}</div>
    </div>
  );
}

class OtherDiscountTooltip extends Component {
  render() {
    const { otherDiscounts, merchantDiscountValue } = this.props;
    if (isEmptyObject(otherDiscounts)) {
      return null;
    }
    return (
      <div style={{ width: '350px' }}>
        {otherDiscounts.map(discount => (
          <OtherDiscountItem key={discount.code} discount={discount} />
        ))}
        <div
          className="row mb-1"
          style={{ borderTop: '1px solid #ffffff', paddingTop: '5px' }}
        >
          <div className="col-9 text-left">{trans('mod_order_detail_total_promotion')}</div>
          <div className="col-3 text-right text-danger">
            -{merchantDiscountValue.text}
          </div>
        </div>
      </div>
    );
  }
}
export default OtherDiscountTooltip;



// WEBPACK FOOTER //
// ./foody/src/pages/Order/OrderManagement/OrderDetail/components/OtherDiscountTooltip.jsx